<template>
  <div class="tickets-root">
    <CButton @click="$emit('back')" class="float-right" color="dark" size="sm">Volver</CButton>
    <div v-if="pointsType == 'event'" class="tickets-title text-info">Puntos para Eventos y Conciertos</div>
    <div v-if="pointsType == 'card'" class="tickets-title text-info">Puntos para Certificados Digitales</div>
    <div v-if="pointsType == 'gift'" class="tickets-title text-info">Puntos para Premios en Especie</div>
    <div v-if="pointsType == 'wallet'" class="tickets-title text-info">Puntos para Dépositos en Monedero</div>
    <hr />
    <table class="w-100" v-if="pointTickets.length > 0">
      <template v-for="(ticket, index) in pointTickets">
        <tr :key="`ticket-${index}`">
          <td>
            {{ ticket.date | date }}<br />
            {{ ticket.description }}
          </td>
          <td class="tickets-points-col text-right font-weight-bold text-info">{{ ticket.points | number }}</td>
        </tr>
        <tr :key="`ticket-divider-${index}`">
          <td colspan="2">
            <hr />
          </td>
        </tr>
      </template>
    </table>
    <div v-else class="text-center w-100">PARTICIPA EN LOS RETOS Y CONCURSOS</div>
  </div>
</template>

<script>
export default {
  name: 'PointsTickets',
  props: {
    pointsType: {
      type: String,
      default: 'event'
    },
    pointTickets: {
      type: Array,
      default: () => []
    }
  }
}
</script>

<style scoped>
.tickets-root {
  font-size: 12px;
}

.tickets-title {
  font-size: 14px;
  font-weight: bold;
}

.tickets-points-col {
  width: 80px;
  font-size: 18px;
}
</style>
